import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "Appointment.AppointmentCardPreviewContainer.title",
    defaultMessage: "Appointment",
  },
});
